<template>
  <div class="container page" style="background: #f4f4f4;">
    <van-nav-bar :title="isEdit ? $t('wallet.edit_title') : $t('wallet.add_title')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#333" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="page-body">
      <!-- 只需要填地址 -->
      <div class="sec-title">{{ $t('wallet.wallet_address') }}</div>
      <van-field
        v-model="address"
        class="mono-field"
        clearable
        :placeholder="$t('wallet.address_placeholder')"
      >
        <template #button>
          <span class="mini-btn" @click="pasteAddress">{{ $t('wallet.paste') }}</span>
        </template>
      </van-field>

      <!-- 资金密码：后端用它校验身份，必填 -->
      <div class="sec-title">{{ $t('wallet.fund_password') }}</div>
      <van-field
        v-model="password"
        type="password"
        clearable
        :placeholder="$t('wallet.password_placeholder')"
      />

      <div class="hint warn">{{ $t('wallet.bind_warn') }}</div>

      <div class="warn-bar" v-if="!hasFundPassword" @click="$router.push({ path: '/SetPayPassword' })">
        {{ $t('wallet.no_fund_password') }} · {{ $t('wallet.set_now') }}
      </div>
    </div>

    <div class="sub-btn" :class="{ disabled: submitting }" @click="!submitting && saveWallet()">
      {{ submitting ? $t('wallet.saving') : (isEdit ? $t('wallet.update_submit') : $t('wallet.add_wallet')) }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {},
      address: '',            // 钱包地址
      password: '',           // 资金密码（后端校验用）
      existingType: '',       // 库里已有的类型，保存时原样带回，避免被清掉
      isEdit: false,          // 是否已有钱包
      hasFundPassword: true,  // 是否已设置资金密码
      submitting: false
    }
  },
  methods: {
    back() {
      return window.history.back()
    },
    // 从剪贴板粘贴地址（部分内置浏览器不支持读取，提示长按粘贴）
    pasteAddress() {
      const fail = () => this.$toast(this.$t('wallet.paste_failed'))
      if (navigator.clipboard && navigator.clipboard.readText) {
        navigator.clipboard.readText().then((text) => {
          const value = (text || '').trim()
          if (value) {
            this.address = value
            this.$toast(this.$t('wallet.pasted'))
          } else {
            fail()
          }
        }).catch(fail)
      } else {
        fail()
      }
    },
    getUserBankInfo() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.code === 200 && res.data) {
          this.hasFundPassword = res.data.has_withdraw_password !== false
          if (res.data.is_bank && res.data.info) {
            const info = res.data.info || {}
            this.isEdit = true
            this.address = info.bankid || ''
            this.existingType = info.bankinfo || info.bankfenhang || ''
          }
        }
      })
    },
    saveWallet() {
      const address = (this.address || '').trim()
      if (address === '') {
        this.$toast.fail(this.$t('wallet.err_address_required'))
        return false
      }
      // 与后端字段长度一致，避免写入被截断
      if (address.length > 100) {
        this.$toast.fail(this.$t('wallet.err_address_length'))
        return false
      }
      if (this.password === '') {
        this.$toast.fail(this.$t('wallet.err_password_required'))
        return false
      }

      this.submitting = true
      const type = this.existingType || 'Wallet'
      this.$http({
        method: 'post',
        url: 'user_set_bank',
        data: {
          bankid: address,                 // 钱包地址
          bank: type,                      // 类型：沿用库里已有的，没有就写 Wallet
          bankfenhang: type,
          username: this.userInfo.name || '',
          withdraw_password: this.password // 资金密码（校验用）
        }
      }).then(res => {
        this.submitting = false
        if (res.code === 200) {
          this.$toast.success(res.msg)
          // 保存后回到提现页，直接看到新的地址
          setTimeout(() => {
            this.$router.replace({ path: '/WithdrawWallet' })
          }, 600)
        } else {
          this.$toast(res.msg || this.$t('wallet.err_save_failed'))
        }
      }).catch(() => {
        this.submitting = false
      })
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data
        } else if (res.code === 401) {
          this.$toast(res.msg)
        }
      })
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    } else {
      this.getUserInfo()
      this.getUserBankInfo()
    }
  }
}
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.page-body{
  padding: 0 30px 40px;
}
.sec-title{
  margin: 40px 0 18px;
  font-size: 28px;
  font-weight: bold;
  color: #333;
}
.hint{
  margin: 16px 4px 0;
  font-size: 24px;
  line-height: 34px;
  color: #999;
  &.warn{ color: #ff4d67; }
}
.warn-bar{
  margin: 24px 0 0;
  padding: 20px 24px;
  background: #fff7e6;
  border: 1px solid #ffd591;
  border-radius: 10px;
  color: #d46b08;
  font-size: 26px;
}
.mini-btn{
  padding-left: 16px;
  font-size: 26px;
  font-weight: bold;
  color: rgb(172, 98, 204);
}
.van-cell{
  background: #fff;
  box-sizing: border-box;
  border: 2px solid #e8e8e8;
  border-radius: 14px;
  font-size: 28px;
  padding: 22px 26px;
  /deep/ .van-field__control{
    color: #333;
  }
  &:after{
    display: none;
  }
}
.mono-field /deep/ .van-field__control{
  font-family: Consolas, Monaco, monospace;
}
.sub-btn{
  background: rgb(172, 98, 204);
  display: block;
  border: none;
  cursor: pointer;
  color: #fff;
  font-size: 32px;
  border-radius: 2rem;
  margin: 20px 40px 60px;
  font-weight: bold;
  text-align: center;
  padding: 20px 0;

  &.disabled {
    background: #999;
    color: #ccc;
    cursor: not-allowed;
  }
}
</style>
